import React, { useEffect, useState } from "react";
import Search from "../../../../components/Search";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import svg27 from "../../../../assets/svg/svg27.svg";
import svg12 from "../../../../assets/svg/svg12.svg";
import svg15 from "../../../../assets/svg/svg15.svg";
import BreadCrumb from "../../../../layout/BreadCrumb";
import { Link, useNavigate } from "react-router-dom";
import CardLoading from "../../../../components/CardLoading";
import IwuaAdd from "./IwuaAdd";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import {
  fetchData,
  fetchLicense,
  fetchSchemeBlocks,
  fetchSchemeCrops,
} from "../../../../features/fetch/fetchSlice";
import moment from "moment";
import { setIwuaObj } from "../../../../features/obj/objSlice";

function IwuaTable() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const url = "sch/get_institutions";
  const urlLicense = "sch/get_institution_licences";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { activeObjSchemes } = useSelector((state) => ({
    activeObjSchemes: state.obj.activeObj["schemes"],
  }));

  const { open, handleCancel, handleOpen } = useModalToggle();
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        instName: e.target.value == "" ? null : e.target.value,
        instSchId:activeObjSchemes?.schId,
        start: 0,
        limit: null,
      })
    );
  };

  const handleEdit = async () => {
    await dispatch(
      fetchData({
        url: urlLicense,
        lcInstId: prodd?.instId,
        limit: null,
        start: 0,
      })
    );
    await handleOpen();
  };
  const handleAdd = async () => {
    await dispatch(
      fetchData({
        url: urlLicense,
        lcInstId: null,
        limit: null,
        start: 0,
      })
    );
    await setProdd();
    await handleOpen();
  };
  const handleView = async () => {
    await dispatch(
      fetchData({
        url: urlLicense,
        lcInstId: prodd?.instId,
        limit: null,
        start: 0,
      })
    );
    await dispatch(setIwuaObj(prodd));
    await navigate("/scheme/iwua-view-list");
  };
  const handleViewName = async (item) => {
    await dispatch(
      fetchData({
        url: urlLicense,
        lcInstId: item?.instId,
        limit: null,
        start: 0,
      })
    );
    await dispatch(setIwuaObj(item));
    await navigate("/scheme/iwua-view-list");
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleView}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 w-4 h-4">
            <img src={svg15} alt="svg15" /> View
          </Link>
        </div>
      ),
    },
  ];

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      render: (item) => {
        return (
          <div className="cursor-pointer" onClick={() => handleViewName(item)}>
            {item?.instName}
          </div>
        );
      },
      sorter: (a, b) => a.instName.localeCompare(b.instName),
    },
    {
      title: "Farmers",
      dataIndex: "instNoOfMembers",
      sorter: (a, b) => a.instNoOfMembers.localeCompare(b.instNoOfMembers),
    },
     {
      title: "Scheme Name",
      dataIndex: "instName",
      sorter: (a, b) => a.instName.localeCompare(b.instName),
    },
    {
      title: "Blocks",
      dataIndex: "instBlocks",
      sorter: (a, b) => a.instBlocks.localeCompare(b.instBlocks),
    },
    {
      title: "Date Registered",
      dataIndex: "instRegCertDate",
      render: (text) => (text ? moment(text).format("DD-MM-YYYY") : "--"),
      sorter: (a, b) =>
        moment(a.instRegCertDate).valueOf() -
        moment(b.instRegCertDate).valueOf(),
    },
    {
      title: "Licenses",
      dataIndex: "instLicense",
      sorter: (a, b) => a.instLicense.localeCompare(b.instLicense),
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];
 
 
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchIwuaData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        instSchId:activeObjSchemes?.schId,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchIwuaData();
    dispatch(
      fetchSchemeCrops({
        blkcSchId: activeObjSchemes?.schId,
      })
    );
    dispatch(fetchSchemeBlocks({ blocSchId: activeObjSchemes?.schId }));
    dispatch(fetchLicense()); 
  }, []);

  if (loading && !searchInput) return <CardLoading />;
  return (
    <div className="lg:min-h-[88vh] flex flex-col">
      <BreadCrumb
        breadcrumbs={[
          { title: "Schemes Overview", path: "/scheme/scheme-overview" },
          { title: "Public", path: "/scheme/public-scheme" },
          { title: `View ${activeObjSchemes?.schName}`, path: "/scheme/public-scheme-view" },
          { title: "IWUA" },
        ]}
      />
 
      <div className="flex flex-col w-full lg:px-[1.25rem] flex-1  white_card mt-[1.25rem]">
        <div className="flex lg:flex-row flex-col-reverse lg:items-center justify-between lg:mt-[1.25rem] gap-y-4">
          <div className="lg:w-[29.1875rem] w-auto ">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search Iwua..."}
            />
          </div>
          <div className="w-[130px]">
            <button onClick={() => handleAdd()} className="cstm-btn-2">
              <span className="">Register New</span>
            </button>
          </div>
        </div>

        <div className="dash-inner-page mt-[1.3rem] max-w-full w-full overflow-x-auto">
          <Table
            rowSelection={false}
            className=" w-full"
            scroll={{
              x: 'max-content',
            }}
            rowKey={(record) => record?.instId}
            columns={columns}
            dataSource={data}
            loading={loading}
            pagination={{
              position: ["bottomRight"],
              current: pageIndex + 1,
              total: count,
              pageSize: pageSize,
              onChange: (page, size) => {
                setPageIndex(page - 1);
                setPageSize(size);
                fetchIwuaData(page - 1, size);
              },
              showSizeChanger: false,
              hideOnSinglePage: true,
            }}
          />
        </div>
      </div>

      <IwuaAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchIwuaData}
        prodd={prodd}
      />
    </div>
  );
}

export default IwuaTable;
